export function splitLocationString(value: string): { [key: string]: string } {
    if (value[0] === '?' || value[0] === '#') {
        value = value.slice(1);
    }

    const map: { [key: string]: string } = {};
    value.split('&').forEach((part) => {
        const pair = part.split('=');
        if (pair[0]) {
            map[pair[0]] = decodeURIComponent(pair[1]);
        }
    });

    return map;
}
